import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/hd_prev_btn.png'
import _imports_1 from '@/assets/common/write_ico.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { class: "header_wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "logo" }, "META HEALTH", -1)
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "page_title2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "개인정보"),
  /*#__PURE__*/_createTextVNode("에 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 동의해주세요! ")
], -1)
const _hoisted_10 = {
  action: "#n",
  method: "post",
  id: "user_form"
}
const _hoisted_11 = { class: "private_box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "private_txt" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ", -1)
const _hoisted_13 = {
  class: "checkbox",
  for: "check"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "개인정보 동의", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "check_form_info" }, "관리자 승인 이후 서비스 이용이 가능합니다.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "menu_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("form", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "",
                  id: "check",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.checkAgree) = $event))
                }, null, 512), [
                  [_vModelCheckbox, $setup.state.checkAgree]
                ]),
                _hoisted_14,
                _hoisted_15
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              id: "submit_btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.joinPage && $setup.joinPage(...args)))
            }, [
              _hoisted_16,
              _createTextVNode("회원가입")
            ]),
            _hoisted_17
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}